module.exports = __webpack_public_path__ + "img/WF_24_dargen_sm.a5110bb3.jpg";